import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Definition } from 'app/core/store/definitions/definition.interface';
import { RootState } from 'app/core/store/index';
import { Observable, of } from 'rxjs';
import { AzureMonitoringService } from '../../services/AzureMonitoringService';
import { BlankReceiptRestService } from '../../services/rest/blank-receipt.rest.service';
import { AbstractEffects } from '../AbstractEffects';
import * as actions from './blank-receipts.actions';
import { BlankReceiptCreateAction, BlankReceiptLocationAction } from './blank-receipts.actions';
import { catchError, debounceTime, map, switchMap } from 'rxjs/operators';
import { NotificationService } from 'app/core/services/notification.service';

@Injectable({ providedIn: 'root' })
export class BlankReceiptsEffects extends AbstractEffects {
  createBlankReceipt$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<BlankReceiptCreateAction>(actions.BLANK_RECEIPT_CREATE),
      debounceTime(50),
      switchMap(
        (
          { payload } // Register to this event, unregister previous if new event occurs.
        ) =>
          this.blankReceiptRestService
            .createBlankReceipt(payload.request) // Create blank receipt
            .pipe(
              map((blob: Blob) => {
                return new actions.BlankReceiptCreateSuccessAction({ blob, filename: 'blank-receipts.pdf' });
              }),
              catchError(err => this.handleFail(err, 'ERRORS.FILTER_FAILED.TITLE', [of(new actions.BlankReceiptCreateFailAction(err))]))
            )
      )
    )
  );
  getBlankReceiptLocations$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<BlankReceiptLocationAction>(actions.BLANK_RECEIPT_LOCATION),
      debounceTime(50),
      switchMap(({ payload }) =>
        this.blankReceiptRestService.getBlankReceiptsLocations(payload.customer.id).pipe(
          map((shipTos: Definition[]) => {
            return new actions.BlankReceiptLocationSuccessAction({ shipTos });
          }),
          catchError(err => this.handleFail(err, 'ERRORS.FILTER_FAILED.TITLE', [of(new actions.BlankReceiptLocationFailAction(err))]))
        )
      )
    )
  );

  constructor(
    private store: Store<RootState>,
    azureMonitoringService: AzureMonitoringService,
    private actions$: Actions,
    private blankReceiptRestService: BlankReceiptRestService,
    translateService: TranslateService,
    notificationService: NotificationService
  ) {
    super(translateService, azureMonitoringService, notificationService);
  }
}
